import $ from 'jquery';
import { convertRGBtoHEX } from '../utilities';

$('.paint-chip').each(function () {
  let rgbRAW = $(this).find('.paint-chip__chip').css('background-color');
  let HEXColor = convertRGBtoHEX(rgbRAW);
  $(this).find('.paint-chip__text').text(HEXColor);
});
